import { __decorate } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import ProductsModule from "@/store/modules/productsApps.module";
import { ProductsEditModel } from "@/store/models/productsApps/ProductEditDTO";
import Switches from "vue-switches";
setInteractionMode("passive");
let Products = /** @class */ (() => {
    let Products = class Products extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Edit Product";
            this.items = [
                {
                    text: "Edit Product",
                },
                {
                    text: "Edit",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedEditProduct = new ProductsEditModel();
            this.ctaButtons = [{ routeName: "Products" }];
        }
        // CRUD
        SaveUpdatedProduct() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    ProductsModule.UpdateProduct(this.selectedEditProduct).then((response) => {
                        this.$router.push({ name: "Products" });
                    });
                }
            });
        }
        cancelProduct() {
            this.selectedEditProduct = new ProductsEditModel();
            this.selectedEditProduct = Object.assign({}, this.selectedEditProduct);
            this.$router.push({ name: "Products" }),
                (this.selectedEditProduct = {
                    id: this.selectedEditProduct.id,
                    name: this.selectedEditProduct.name,
                    description: this.selectedEditProduct.description,
                    owner: this.selectedEditProduct.owner,
                    startedYear: this.selectedEditProduct.startedYear,
                    domain: this.selectedEditProduct.domain,
                    status: this.selectedEditProduct.status,
                });
        }
        // COMPUTED
        get Product() {
            return ProductsModule.productEdit;
        }
        // LIFECYCLE
        created() {
            var productId = Guid.parse(this.$route.params.productId);
            ProductsModule.GetProductEditById(productId).then((response) => {
                this.pageIsLoading = false;
                this.selectedEditProduct = new ProductsEditModel();
                this.selectedEditProduct = {
                    id: this.Product.id,
                    name: this.Product.name,
                    description: this.Product.description,
                    owner: this.Product.owner,
                    startedYear: this.Product.startedYear,
                    domain: this.Product.domain,
                    status: this.Product.status,
                };
            });
        }
    };
    Products = __decorate([
        Component({
            name: "EditProducts",
            components: {
                Layout,
                PageHeader,
                Switches,
            },
        })
    ], Products);
    return Products;
})();
export default Products;
